import { Dialog, DialogTitle, DialogActions, Button } from '@mui/material';
import React from 'react';
import { useTranslation } from 'react-i18next';

type MemberUpdateConfirmProps = {
  callback: (accepted: boolean) => void;
  abortMode: boolean;
  onClose: () => void;
};

export const MemberUpdateConfirm = (props: MemberUpdateConfirmProps) => {
  const { callback, abortMode, onClose } = props;
  const { t } = useTranslation(['common', 'member']);
  const [open, setOpen] = React.useState(true);

  const confirm = () => {
    callback(true);
    setOpen(false);
  };

  const handleClose = () => {
    setOpen(false);
    onClose();
  };

  return (
    <Dialog open={open} onClose={handleClose} aria-labelledby='alert-dialog-title' aria-describedby='alert-dialog-description'>
      <DialogTitle id='alert-dialog-title'>{abortMode ? t('member:memberUpdate.cancelReview') : t('member:memberUpdate.acceptReview')}</DialogTitle>
      <DialogActions sx={{ '& .MuiButton-text': { fontWeight: 600 } }}>
        <Button disableElevation variant='outlined' onClick={handleClose}>
          {t('common:button.no')}
        </Button>
        <Button disableElevation onClick={confirm} variant='contained' autoFocus>
          {t('common:button.yes')}
        </Button>
      </DialogActions>
    </Dialog>
  );
};
